<template>
  <base-modal @close="handleClose()">
    <template #main>
      <div class="actual-msi-info-modal">
        <div class="modal-header">
          <img
            @click.stop="handleClose()"
            class="close-image"
            :class="{ 'close-image-disabled': isConfirmLoading }"
            src="../../../../public/custom/images/cross.svg"
            alt="Cross image"
          >
        </div>
        <div class="actual-msi-info-modal-title">
          {{ $t('message.settingsPage.actualizeDataViaMsi.modal.title') }}
        </div>
        <div class="actual-msi-info-modal-description">
          {{ $t(descriptionKey) }}
        </div>
        <div class="actual-msi-info-modal-btns">
          <div class="actual-msi-info-modal-btn">
            <base-button
              :text="$t('message.settingsPage.actualizeDataViaMsi.modal.cancelBtn')"
              class="cancel-btn"
              :min-height="'40px'"
              :disabled="isConfirmLoading"
              @click="handleClose()"
            />
          </div>
          <div class="actual-msi-info-modal-btn">
            <base-button
              :text="$t('message.settingsPage.actualizeDataViaMsi.modal.confirmBtn')"
              :min-height="'40px'"
              :is-loading="isConfirmLoading"
              :disabled="isConfirmLoading"
              @click="confirmActualize()"
            />
          </div>
        </div>
      </div>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '../../../components/base/BaseModal.vue';
import BaseButton from '../../../components/base/BaseButton.vue';

export default {
  name: 'ActualMsiInfoModal',
  inject: ['$httpService'],
  components: {
    BaseModal,
    BaseButton
  },
  props: {
    descriptionKey: {
      type: String,
      default: 'message.settingsPage.actualizeDataViaMsi.modal.description'
    }
  },
  data() {
    return {
      isConfirmLoading: false
    };
  },
  methods: {
    handleClose() {
      if (this.isConfirmLoading) {
        return;
      }

      this.$emit('close');
    },
    async confirmActualize() {
      if (this.isConfirmLoading) {
        return;
      }

      this.isConfirmLoading = true;

      try {
        const response = await this.$httpService.auth.getActualMsiInfoRedirectUrl();
        const url = response.data.url;

        window.location.href = url;
      } catch (error) {
        this.isConfirmLoading = false;
        this.$emit('close');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.actual-msi-info-modal {
  width: 480px;
  max-width: calc(95vw - 30px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
}

.modal-header {
  @include modal-close-block;

  width: 100%;
}

.close-image {
  cursor: pointer;
}

.close-image-disabled {
  cursor: default;
  pointer-events: none;
}

.actual-msi-info-modal-title {
  margin-bottom: 12px;
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: 0.1px;
  color: #022131;
}

.actual-msi-info-modal-description {
  width: 440px;
  max-width: 100%;
  margin-bottom: 40px;
  font-size: 14px;
  line-height: 22px;
  color: #022131;
}

.actual-msi-info-modal-btns {
  width: 440px;
  max-width: 100%;
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
}

.actual-msi-info-modal-btn {
  flex: 1;
  height: 40px;
}

.cancel-btn ::v-deep {
  background-color: white;
  border: 2px solid #41BF7B;
  box-sizing: border-box;
  color: #41BF7B;

  &:hover {
    color: white;
  }
}
</style>
